<template>
  <add-edit-dialog v-show="visible">
    <crm-panel title="新增销售线索">
      <div class="page-buttons">
        <div style="display:inline-block">
          <crm-UploadAdd :handleUploadSucess="handleUploadSucess" />
        </div>
        <crm-button :text="'保存'" @click="handleSave()"> </crm-button>
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCancel()"
        >
        </crm-button>
      </div>
      <el-form
        label-width="160px"
        ref="form"
        :model="form"
        :rules="formRules"
        class="add-edit-form"
      >
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司：" prop="companyName">
              <el-input v-model="form.companyName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="部门：" prop="department">
              <el-input v-model="form.department"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职务：" prop="duty">
              <el-input v-model="form.duty"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="来源：" prop="cluesSource">
              <el-select clearable filterable v-model="form.cluesSource">
                <el-option
                  v-for="item in clueSource"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="意向：" prop="intention">
              <el-input type="textarea" :rows="4" v-model="form.intention">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="联系方式：" prop="mobile">
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地区：" prop="locataion">
              <el-cascader
                clearable
                placeholder="地区"
                v-model="level3Linkage.selected"
                :props="level3Linkage.props"
                :options="level3Linkage.options"
                @change="searchDistrict(level3Linkage.selected)"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="详细地址：" prop="streetAddress">
              <el-input type="textarea" :rows="4" v-model="form.streetAddress">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :offset="3">
            <el-form-item label="业务员：" prop="salesmanCode">
              <el-select clearable filterable v-model="form.salesmanCode">
                <el-option
                  v-for="item in allSalesman"
                  :label="`${item.userName} - ${item.loginId}`"
                  :value="item.code"
                  :key="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </crm-panel>
  </add-edit-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import city from '@/scripts/city-diction';
import AddEditDialog from '@/components/base/addEditDialog';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmUploadAdd from '@/components/base/crmUploadAdd';

export default {
  props: {
    visible: Boolean,
  },
  components: {
    AddEditDialog,
    CrmPanel,
    CrmButton,
    CrmUploadAdd,
  },
  data() {
    return {
      form: {
        name: null,
        companyName: null,
        department: null,
        duty: null,
        cluesSource: null,
        intention: null,
        mobile: null,
        province: null,
        city: null,
        district: null,
        streetAddress: null,
        salesmanCode: null,
      },
      formRules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          { max: 10, message: '最多10个字', trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: '请填写公司', trigger: 'blur' },
          { max: 50, message: '最多50个字', trigger: 'blur' },
        ],
        intention: [
          { required: true, message: '请填写意向', trigger: 'blur' },
          { max: 100, message: '最多100个字', trigger: 'blur' },
        ],
        salesmanCode: [
          { required: true, message: '请选择业务员', trigger: 'change' },
        ],
        department: [{ max: 20, message: '最多20个字', trigger: 'blur' }],
        duty: [{ max: 20, message: '最多20个字', trigger: 'blur' }],
        mobile: [
          { max: 20, message: '最多20个字', trigger: 'blur' },
          {
            min: 8,
            message: '请输入不少于8位的固话或者手机号',
            trigger: 'blur',
          },
          {
            pattern: /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/,
            message: '请输入固话或者手机号',
          },
        ],
        streetAddress: [{ max: 100, message: '最多100个字', trigger: 'blur' }],
      },
      // 省/市/区三级联动
      level3Linkage: {
        options: city,
        props: {
          label: 'label',
          value: 'label',
          expandTrigger: 'click',
          checkStrictly: true,
        },
        selected: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      allSalesman: 'clue/allSalesman',
      clueSource: 'common/clueSource',
      userInfo: 'authority/userInfo',
    }),
  },
  watch: {
    visible(val) {
      if (val) this.$refs.form.resetFields();
      if (!this.allSalesman.length) this.getAllSalesman();
      if (!this.clueSource.length) {
        this.getClueSource({
          pageNumber: 1,
          pageSize: 100,
          code: 'category_clues_source',
        });
      }

      this.form.salesmanCode = this.userInfo.userUid;
    },
  },
  methods: {
    ...mapActions({
      getClueSource: 'common/getClueSource',
      getAllSalesman: 'clue/getAllSalesman',
      addClue: 'clue/addClue',
    }),
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.addClue(this.form)
            .then(() => {
              this.$message.success('新增成功！');
              this.$emit('success');
              this.$emit('close');
              this.level3Linkage.selected = [];
            })
            .catch(() => {});
        }
      });
    },
    handleCancel() {
      this.$emit('close');
      this.level3Linkage.selected = [];
    },
    // 以区域筛选客户
    searchDistrict(val) {
      const [provinceName, cityName, districtName] = val;
      this.form.province = provinceName;
      this.form.city = cityName;
      this.form.district = districtName;
    },
    handleUploadSucess(data) {
      this.form = {
        ...this.form,
        name: data.NAME[0],
        companyName: data.name,
        department: data.department,
        duty: data.TITLE[0],
        mobile: data.MOBILE[0],
        province: data.province,
        city: data.city,
        district: data.district,
        streetAddress: data.streetAddress,
      };
      this.level3Linkage.selected = [data.province, data.city, data.district];
    },
  },
};
</script>

<style></style>
